import { deleteCustomField, getCustomFieldsList } from './actions/CustomFieldActions';
import { Field, reduxForm, reset } from 'redux-form';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PaginatorCustom from './../../../../components/paginationCustom';
import CustomFieldModal from './custom_field_modal';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import { renderTextField } from './../../../../components/reduxFields';
import { alertConfirmation } from './../../../../actions/utilAction';
import SortingCustom from './../../../../components/SortingCustom';
import { resetFiltersAndSorting } from '../../../../actions/utilAction';


class CustomField extends React.Component {

  constructor(props) {
    super(props);
    this.state = ({
      open: false,
      customFieldId: null,
    });

    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };

    this.renderCustomField = this.renderCustomField.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  };
  componentWillMount() {
    this.loadData();
  };
  componentWillUnmount() {
    Alert.closeAll();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_customField && this.props.saved_customField !== nextProps.saved_customField) {
      this.loadData();
    }
    if (nextProps.deleted_customField && this.props.deleted_customField !== nextProps.deleted_customField) {
      this.loadData();
    }
  };

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getCustomFieldsList(searchObj);
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, customFieldId: null });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleEditClick = (event, customFieldObj) => {
    Alert.closeAll();
    this.setState({ open: true, customFieldId: customFieldObj.id });

  };

  handleAlertClick = (event, id) => {
    this.props.deleteCustomField(id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, customFieldObj) => {
    alertConfirmation('Once you click yes, all the staff and clients linked with this custom field will get effected. Are you sure you want to delete this custom field?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: customFieldObj.id,
      },
    });
  };
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  };
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('CustomFieldForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadData();
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }

  handleSubmitSearch() {
    return false;
  }

  renderCustomField(customFieldsList) {
    customFieldsList = customFieldsList || [];
    if (!customFieldsList.length) {
      return (
        <tr><td colSpan="3" className="text-center no-record">{this.props.loading ? 'loading please wait...' : 'No record found.'}</td></tr>
      );
    }

    return customFieldsList.map((obj, index) => {
      return (
        <tr key={index}>
          <td width="40%">{obj.customLabelName}</td>
          <td width="40%">{obj.roleTypeName}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td width="20%">
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit, customFieldsData } = this.props;
    let customFieldsList = (customFieldsData && customFieldsData.data) || [];
    let customFieldsMeta = (customFieldsData && customFieldsData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ?
          <CustomFieldModal closeDialog={this.handleClose} customFieldId={this.state.customFieldId} />
          : null}
        <h2 className="page_title">Manage Custom Fields</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className='row'>
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Custom Field" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                        <Field
                          name="CustomField"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton}>Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 mt-15">
                <div className="table-responsive">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="45%">
                          <SortingCustom noSort={!customFieldsList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Name' />
                        </th>
                        <th width='45%'>
                          <SortingCustom noSort={!customFieldsList.length} setSortColumn={this.setSortColumn} columnName='linkTo' displayName='Link To' /></th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="10%">Actions</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderCustomField(customFieldsList)}
                    </tbody>
                  </table>

                </div>
                {customFieldsMeta && customFieldsMeta['totalPages'] ?
                  <PaginatorCustom data={customFieldsMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_CUSTOMFIELDS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CUSTOMFIELDS_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CUSTOMFIELDS_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CUSTOMFIELDS_LIST_DELETE')[0].permission : false;


  // End For Role Permission

  return {
    loading: state.custom_field.loading,
    customFieldsData: state.custom_field.customFieldsList,
    saved_customField: state.custom_field.saved_customField,
    deleted_customField: state.custom_field.deleted_customField,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}
CustomField = reduxForm({
  form: 'CustomFieldForm',
})(CustomField);

export default connect(mapStateToProps, { deleteCustomField, getCustomFieldsList })(CustomField);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/custom_field.js